import { Modal } from "antd";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthModalContext } from "../../Contexts/AuthModalContext";
import RegisterForm from "./RegisterForm";
import SignInForm from "./SignInForm";

// Single instance of the sign in / sign up modal, mounted once near the router.
// Anything in the tree opens it through AuthModalContext, which is why login no
// longer has a page of its own.
const AuthModal = () => {
    const navigate = useNavigate();
    const { authModal, dfCard, redirectTo, openSignIn, openRegister, closeAuthModal } =
        useContext(AuthModalContext);

    if (!authModal) return null;

    const handleSuccess = () => {
        const target = redirectTo;
        closeAuthModal();
        if (target) navigate(target, { replace: true });
    };

    return (
        <Modal
            title={null}
            footer={null}
            open={Boolean(authModal)}
            onCancel={closeAuthModal}
            centered
            destroyOnClose
            width={authModal === "register" ? 560 : 440}
        >
            {authModal === "signin" ? (
                <SignInForm
                    onSuccess={handleSuccess}
                    onSwitchToRegister={() => openRegister({ redirectTo })}
                    onClose={closeAuthModal}
                />
            ) : (
                <RegisterForm
                    dfCard={dfCard}
                    onSuccess={handleSuccess}
                    onSwitchToSignIn={() => openSignIn({ redirectTo })}
                    onClose={closeAuthModal}
                />
            )}
        </Modal>
    );
};

export default AuthModal;
